import { useContext } from 'react';
import EditIcon from '../../../assets/icons/edit.svg';
import WhiteEditIcon from '../../../assets/icons/WhiteEditIcon.svg';
import { ThemeContext } from '../../../theme/ThemeContext';

const AgentCards = ({ icon, name, role = "Support", status = "Active", onEdit }) => {
  const { theme } = useContext(ThemeContext);
  const isDark = theme === "dark";
  return (
    <div className="text-center agent-card p-3">
      <div className="profile-img-wrapper mx-auto mb-2">
        <img
          src={icon}
          alt={name}
          className="img-fluid rounded-circle profile-img"
        />
      </div>
      <div className="d-flex align-items-center justify-content-center gap-2 mb-1">
        <h6 className="fw-bold mb-0">{name}</h6>
        <img
          src={isDark ? WhiteEditIcon : EditIcon}
          alt="edit"
          style={{ width: "22px", height: "22px", cursor: "pointer" }}
          onClick={(e) => {
            e.stopPropagation();
            onEdit();
          }}
        />
      </div>

      <p className="fst-italic mb-1">{role}</p>
      <div className="d-flex align-items-center justify-content-center gap-1">
        <span
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: status === "Active" ? "#28a745" : "#aaa",
            display: "inline-block",
          }}
        ></span>
        <small style={{ color: status === "Active" ? "#28a745" : "#aaa" }}>{status}</small>
      </div>
    </div>
  );
};
export default AgentCards;
